/**
 * Maven — extras do carrinho
 *
 * Dois elementos, os dois desenhados para viverem dentro da gaveta do carrinho.
 * A gaveta e reescrita de raiz (innerHTML) sempre que o carrinho muda, por isso
 * nada aqui pode viver num <script> la dentro: sao *custom elements*, que o
 * navegador volta a ligar sozinho a cada nova pintura.
 *
 *   <mvn-cronometro>  contagem decrescente de 10 minutos
 *   <mvn-desconto>    barra de progresso ate aos descontos por valor
 */

/* ------------------------------------------------------------------ */
/* Cronometro                                                          */
/* ------------------------------------------------------------------ */
if (!customElements.get('mvn-cronometro')) {
  const CHAVE_FIM = 'mvnReservaFim';
  const CHAVE_ITENS = 'mvnReservaItens';

  class MvnCronometro extends HTMLElement {
    connectedCallback() {
      this.relogio = this.querySelector('[data-relogio]');
      this.frase = this.querySelector('[data-frase]');
      this.risco = this.querySelector('.mvn-cron__barra i');
      this.minutos = parseInt(this.dataset.minutos, 10) || 10;
      this.duracao = this.minutos * 60 * 1000;

      this.decideOFim();
      this.pinta();
      this.relogioInterno = setInterval(() => this.pinta(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.relogioInterno);
    }

    /*
     * Quando e que a contagem recomeca:
     *  - nao ha nada guardado;
     *  - entrou mais uma camisola no carrinho;
     *  - o prazo acabou ha mais de meia hora (quem volta amanha nao merece
     *    encontrar um cronometro parado a zero).
     */
    decideOFim() {
      const agora = Date.now();
      const itensAgora = parseInt(this.dataset.itens, 10) || 0;
      let fim = parseInt(localStorage.getItem(CHAVE_FIM), 10);
      const itensAntes = parseInt(localStorage.getItem(CHAVE_ITENS), 10) || 0;

      const recomeca =
        !fim ||
        isNaN(fim) ||
        itensAgora > itensAntes ||
        agora - fim > 30 * 60 * 1000;

      if (recomeca) {
        fim = agora + this.duracao;
        localStorage.setItem(CHAVE_FIM, String(fim));
      }
      localStorage.setItem(CHAVE_ITENS, String(itensAgora));
      this.fim = fim;
    }

    pinta() {
      const falta = this.fim - Date.now();

      if (falta <= 0) {
        this.classList.add('acabou');
        if (this.relogio) this.relogio.textContent = '00:00';
        if (this.frase && this.dataset.fraseFim) this.frase.textContent = this.dataset.fraseFim;
        if (this.risco) this.risco.style.width = '0%';
        clearInterval(this.relogioInterno);
        return;
      }

      const m = Math.floor(falta / 60000);
      const s = Math.floor((falta % 60000) / 1000);
      if (this.relogio) {
        this.relogio.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      }
      if (this.risco) this.risco.style.width = (falta / this.duracao) * 100 + '%';
      /* Os ultimos dois minutos ficam vermelhos. */
      this.classList.toggle('urgente', falta < 2 * 60 * 1000);
    }
  }

  customElements.define('mvn-cronometro', MvnCronometro);
}

/* ------------------------------------------------------------------ */
/* Barra dos descontos por valor                                       */
/* ------------------------------------------------------------------ */
if (!customElements.get('mvn-desconto')) {
  /* Amarelo no principio, verde no fim. O tom anda com o progresso, por isso
     quando o cliente esta quase na primeira bola a barra ja esta esverdeada. */
  const TOM_INICIO = 46;
  const TOM_FIM = 122;

  const cor = (progresso, luz) =>
    'hsl(' + Math.round(TOM_INICIO + (TOM_FIM - TOM_INICIO) * progresso) + ',72%,' + luz + '%)';

  class MvnDesconto extends HTMLElement {
    connectedCallback() {
      /*
       * Os degraus vem em centimos da moeda da loja. A taxa do Shopify passa-os
       * para a moeda que o cliente esta a ver — sem isto, um cliente em dolares
       * via a barra a mentir-lhe. E o mesmo caminho que o tema ja usa nos
       * portes gratis.
       */
      const taxa = (window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
      const total = parseInt(this.dataset.total, 10) || 0;
      const d1 = Math.round(parseInt(this.dataset.degrau1, 10) * taxa);
      const d2 = Math.round(parseInt(this.dataset.degrau2, 10) * taxa);

      const frase = this.querySelector('[data-frase]');
      const emoji = this.querySelector('[data-emoji]');
      const risco = this.querySelector('.mvn-desc__barra i');
      const bola1 = this.querySelector('[data-bola="1"]');
      const bola2 = this.querySelector('[data-bola="2"]');

      /* As legendas por baixo de cada bola: quanto e preciso, e quanto se ganha. */
      const legs = this.querySelectorAll('.mvn-desc__leg');
      if (legs[0]) {
        legs[0].querySelector('[data-valor]').textContent = this.dinheiro(d1);
        legs[0].querySelector('[data-pct]').textContent = this.dataset.pct1 || '';
      }
      if (legs[1]) {
        legs[1].querySelector('[data-valor]').textContent = this.dinheiro(d2);
        legs[1].querySelector('[data-pct]').textContent = this.dataset.pct2 || '';
      }

      /*
       * A primeira bola fica a meio da pista, a segunda no fim: metade da barra
       * para o primeiro degrau, metade para o segundo.
       */
      let porCento;
      let texto = '';
      let cara = '🎁';
      let nivel = 0;

      if (total < d1) {
        porCento = (total / d1) * 50;
        texto = this.montaFrase(this.dataset.fraseFalta1, d1 - total);
      } else if (total < d2) {
        nivel = 1;
        cara = '🎉';
        porCento = 50 + ((total - d1) / (d2 - d1)) * 50;
        texto = this.montaFrase(this.dataset.fraseFalta2, d2 - total);
      } else {
        nivel = 2;
        cara = '🔥';
        porCento = 100;
        texto = this.dataset.fraseMax || '';
      }

      const progresso = porCento / 100;
      const corAgora = cor(progresso, 40);

      if (frase) frase.textContent = texto;
      if (emoji) emoji.textContent = cara;
      this.dataset.nivel = String(nivel);
      this.style.setProperty('--mvn-cor', corAgora);

      if (risco) {
        risco.style.background = 'linear-gradient(90deg,' + cor(0, 52) + ' 0%,' + corAgora + ' 100%)';
      }
      if (bola1) bola1.classList.toggle('atingida', nivel >= 1);
      if (bola2) bola2.classList.toggle('atingida', nivel >= 2);
      if (legs[0]) legs[0].classList.toggle('atingida', nivel >= 1);
      if (legs[1]) legs[1].classList.toggle('atingida', nivel >= 2);

      /* Um instante antes de mexer, para o browser animar a largura. */
      requestAnimationFrame(() => {
        if (risco) risco.style.width = porCento + '%';
      });
    }

    /*
     * O formato do tema esta preso a moeda da loja: quem escolhia libras via a
     * conta certa mas com o simbolo do euro a frente. Quem manda e a moeda que
     * o cliente tem escolhida, e o proprio navegador sabe formata-la.
     */
    dinheiro(centimos) {
      const moeda = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      const lingua =
        (window.Shopify && Shopify.locale) || document.documentElement.lang || 'pt-PT';
      try {
        return new Intl.NumberFormat(lingua, {
          style: 'currency',
          currency: moeda,
          minimumFractionDigits: 2
        }).format(centimos / 100);
      } catch (e) {
        const formato =
          (window.theme && window.theme.settings && window.theme.settings.money_format) ||
          '€{{amount_with_comma_separator}}';
        return typeof formatMoney === 'function'
          ? formatMoney(centimos, formato)
          : (centimos / 100).toFixed(2);
      }
    }

    montaFrase(modelo, centimos) {
      if (!modelo) return '';
      /* O Liquid entrega a frase com um @@ no lugar do dinheiro: assim a ordem
         das palavras fica a cargo de cada lingua. */
      return modelo.replace('@@', this.dinheiro(centimos));
    }
  }

  customElements.define('mvn-desconto', MvnDesconto);
}


/* ------------------------------------------------------------------ */
/* O «menos» na quantidade 1 tira a camisola do carrinho               */
/* ------------------------------------------------------------------ */
/*
 * O selector de quantidade do tema tem min="1" e nunca desce a zero: quem
 * carregava no menos com uma camisola so ficava preso, sem perceber que tinha
 * de ir ao caixote do lixo. Apanhamos o clique antes do tema (fase de captura)
 * e, se ja esta em 1, pomos o campo a zero e damos o mesmo aviso que o tema
 * espera — dai para a frente e ele que remove a linha, na gaveta ou na pagina
 * do carrinho.
 */
if (!window.__mvnMenosLigado) {
  window.__mvnMenosLigado = true;
  document.addEventListener(
    'click',
    (e) => {
      const botao = e.target.closest && e.target.closest('quantity-selector .minus');
      if (!botao) return;
      const caixa = botao.closest('quantity-selector');
      const campo = caixa && caixa.querySelector('.qty');
      if (!campo || Number(campo.value) > 1) return;

      e.preventDefault();
      campo.value = 0;
      campo.dispatchEvent(new Event('change', { bubbles: true }));
    },
    true
  );
}

/* ------------------------------------------------------------------ */
/* Fazer deslizar a caixa das sugestoes                                */
/* ------------------------------------------------------------------ */
/*
 * No computador a caixa das sugestoes vive escondida atras da gaveta e so
 * aparece quando alguem lhe poe a classe `active`. O tema fazia isso quando
 * era ele a construir as recomendacoes; como as nossas sugestoes sao feitas em
 * Liquid, ha caminhos de abertura em que ninguem a chama. Tratamos disso aqui,
 * sempre que a gaveta abre.
 */
if (!window.__mvnSugestoesLigado) {
  window.__mvnSugestoesLigado = true;

  const mostra = () => {
    const gaveta = document.getElementById('Cart-Drawer');
    if (!gaveta || !gaveta.classList.contains('active')) return;
    const caixa = gaveta.querySelector('.product-recommendations--full');
    if (caixa) caixa.classList.add('active');
  };

  document.addEventListener('cart-drawer:open', () => setTimeout(mostra, 60));

  const gaveta = document.getElementById('Cart-Drawer');
  if (gaveta) {
    new MutationObserver(() => setTimeout(mostra, 60)).observe(gaveta, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: false
    });
  }
}
